<html>
    <head>
    </head>

    <body>
        <div class="intro">

            <!-- Title -->
            <h1>
                <span id="title" class="pacificofont">Yes MultiServices</span>
            </h1>
            <!-- Title -->


            <!-- Error Message -->
            <div *ngIf="msg==='**Invalid Username or Password'">
                <p id="error" style="text-align:center;font-size:
                    16px;color:red;"><b>{{msg}}</b></p><br><hr>
            </div>
            <!-- Error Message -->

            <!-- Login Form -->
            <form #loginForm="ngForm" (ngSubmit)="login(loginForm)">
                <br>

                <!-- username Input -->
                <div>
                    <div class="form-group">
                        <label id="input_label"
                            for="username">Username</label>
                        <input #username="ngModel"
                            required
                            type="text" class="form-control"
                            id="username"
                            autocomplete="off"
                            aria-describedby="username" placeholder="Enter Your Username" ngModel name="username">
                    </div>
                    <!-- username Input -->


                    <!-- password Input -->
                    <div class="form-group">
                        <label id="input_label"
                            for="password">Password</label>
                        <input #password="ngModel"
                            required
                            type="password" class="form-control"
                            id="password"
                            autocomplete="off"
                            aria-describedby="password" placeholder="Enter Your Password" ngModel name="password">
                    </div>
                    <!-- password Input -->


                    <!-- Submit Button -->
                    <button id="submit_button" type="submit"
                        [disabled]="loginForm.invalid" class="btn
                        btn-outline-info">Login</button>
                    <!-- Submit Button -->


                </div>
            </form>
            <!-- Login Form -->


        </div>
    </body>
</html>

<router-outlet></router-outlet>